// extracted by mini-css-extract-plugin
export default {"root":"demo-request_root__vt06o","card":"demo-request_card__j4kEZ","text":"demo-request_text__j+Y+y","button":"demo-request_button__QNFaa"};